import React, { useState } from "react"
import { FaFilePdf, FaCalendarAlt, FaTicketAlt, FaStar, FaMoneyBill, FaWallet, FaInfoCircle,FaTimes} from "react-icons/fa"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import type { PressData } from "../models/listpress"
import "../css/Validation.css"
import "../css/ValidationHeader.css"
import SoldeRemiseModal from "./SoldeRemiseModal"
import { applySoldeRemise } from "../services/Solde_service"
import { Dropdown } from "react-bootstrap"

interface ValidationHeaderProps {
  selectedSupport: PressData | null
  txtAnnonce: string
  startDate: Date | null
  showDatePicker: boolean
  setShowDatePicker: (show: boolean) => void
  handleDateChange: (date: Date | null) => void
  generatePDF: () => void
  loading: boolean
  user: any
  remisePourcentage: number
  commissionVal: number
  codePromoVal: number
  remisePointsEuros: number
  remiseAvoirsEuros: number
  remiseSoldeEuros: number
  prixHT: number
  prixTTC: number
  amountToPay: number
  isFreeAnnouncement: boolean
  appliedDiscount: number | null
  pendingPromo: any
  availableAvoirs: any[]
  setShowPromoModal: (show: boolean) => void
  setShowPointsModal: (show: boolean) => void
  setShowAvoirsModal: (show: boolean) => void
  showSoldeRemiseModal: boolean
  setShowSoldeRemiseModal: (show: boolean) => void
  setRemiseSoldeEuros: (amount: number) => void
  selectedBillingClient: any
  setShowBillingClientModal: (show: boolean) => void
  handleRemoveBillingClient: () => void
  wantsBilling: boolean
  discountPercentageAmount?: number
  pointsDiscountAmount?: number
  creditNoteDiscountAmount?: number
  soldeRemiseDiscountAmount?: number
  totalDiscountAmount?: number
  discountClaimed: boolean
  setDiscountClaimed: (value: boolean) => void
  discountSentToClient: boolean
  setDiscountSentToClient: (value: boolean) => void
  setUser: (user: any) => void
  setRemisePointsEuros: (amount: number) => void 
  setRemiseAvoirsEuros: (amount: number) => void  
  resetPromoCode?: () => void 
}

const ValidationHeader: React.FC<ValidationHeaderProps> = ({
  selectedSupport,
  txtAnnonce,
  startDate,
  showDatePicker,
  setShowDatePicker,
  handleDateChange,
  generatePDF,
  loading,
  user,
  remisePourcentage,
  commissionVal,
  codePromoVal,
  remisePointsEuros,
  remiseAvoirsEuros,
  remiseSoldeEuros,
  prixHT,
  prixTTC,
  amountToPay,
  isFreeAnnouncement,
  appliedDiscount,
  pendingPromo,
  availableAvoirs,
  setShowPromoModal,
  setShowPointsModal,
  setShowAvoirsModal,
  showSoldeRemiseModal,
  setShowSoldeRemiseModal,
  setRemiseSoldeEuros,
  selectedBillingClient,
  setShowBillingClientModal,
  handleRemoveBillingClient,
  wantsBilling,
  discountPercentageAmount,
  pointsDiscountAmount,
  creditNoteDiscountAmount,
  soldeRemiseDiscountAmount,
  totalDiscountAmount,
  discountClaimed,
  setDiscountSentToClient,
  discountSentToClient,
  setDiscountClaimed,
  setUser, 
  setRemisePointsEuros, 
  setRemiseAvoirsEuros, 
  resetPromoCode
}) => {
  const [showSendToClientModal, setShowSendToClientModal] = useState(false)
  const [availableSoldeRemise, setAvailableSoldeRemise] = useState(user?.soldeRemise || 0)
  const [showTooltip, setShowTooltip] = useState(false)

  // État pour gérer le choix de l'utilisateur (déduire maintenant par défaut)
  const [discountChoice, setDiscountChoice] = useState<"deduct" | "conserve">("deduct")

  const [localAmountToPay, setLocalAmountToPay] = useState(amountToPay);

  React.useEffect(() => {
    const newAmount =
      prixTTC -
      ((pointsDiscountAmount ?? 0) +
        (creditNoteDiscountAmount ?? 0) +
        (remiseSoldeEuros ?? 0) +
        (discountPercentageAmount ?? 0));
    setLocalAmountToPay(newAmount);
  }, [pointsDiscountAmount, creditNoteDiscountAmount, remiseSoldeEuros, discountPercentageAmount, prixTTC]);


  const handleClick = () => {
    setShowTooltip(prev => !prev)
  }

  const hasAnyDiscount =
    (discountPercentageAmount ?? 0) > 0 ||
    (pointsDiscountAmount ?? 0) > 0 ||
    (creditNoteDiscountAmount ?? 0) > 0 ||
    (remiseSoldeEuros ?? 0) > 0

const DiscountItem = ({
  icon,
  label,
  onClick,
  disabled = false,
  hasDiscount = false,
  onRemove,
}: {
  icon: React.ReactNode
  label: string
  onClick: () => void
  disabled?: boolean
  hasDiscount?: boolean
  onRemove?: () => void
}) => (
  <div
    className={`d-flex align-items-center justify-content-between gap-2 px-3 py-2 rounded ${
      disabled ? "text-muted" : "valhead-dropdown-item"
    }`}
    style={{
      cursor: disabled ? "not-allowed" : "pointer",
      opacity: disabled ? 0.6 : 1,
    }}
  >
    <div
      className="d-flex align-items-center gap-2 flex-grow-1"
      onClick={!disabled ? onClick : undefined}
      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
    >
      <span style={{ width: 20 }}>{icon}</span>
      <span className="fw-medium">{label}</span>
    </div>
    {hasDiscount && onRemove && (
      <FaTimes
        style={{
          cursor: "pointer",
          color: "#dc3545",
          fontSize: "35px",
          padding: "4px",
          borderRadius: "50%",
          transition: "all 0.2s",
        }}
        onClick={(e) => {
          e.stopPropagation()
          onRemove()
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#dc354520"
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent"
        }}
        title="Annuler cette remise"
      />
    )}
  </div>
)

  // Calcul du prix avec remise
  const priceWithDiscount = prixTTC - ((pointsDiscountAmount ?? 0) + (creditNoteDiscountAmount ?? 0) + (remiseSoldeEuros ?? 0) + (discountPercentageAmount ?? 0));
  const amountToCreditInAvoirs = totalDiscountAmount ?? 0

  const handleDatePickerClick = () => setShowDatePicker(!showDatePicker)

  const handleDiscountChoiceChange = (choice: "deduct" | "conserve") => {
    setDiscountChoice(choice)

    if (choice === "conserve") {
      // Logique pour "Conserver la remise dans mes avoirs"
      setDiscountClaimed(true)
      setDiscountSentToClient(false)
    } else {
      // Logique pour "Déduire la remise maintenant"
      setDiscountClaimed(false)
      setDiscountSentToClient(false)
    }
  }

  const handleSoldeSent = () => {
    setDiscountSentToClient(true)
    setDiscountClaimed(false)
  }

  const handleApplySoldeRemise = async (amountToUse: number) => {
    try {
      const newSolde = await applySoldeRemise(user.id, amountToUse)
      setRemiseSoldeEuros(amountToUse)
      setAvailableSoldeRemise(newSolde)
      console.log("Nouveau solde après utilisation :", newSolde)
    } catch (err: any) {
      alert(err.message || "Erreur lors de l'utilisation du solde remise")
    }
  }

  const handleRemoveDiscount = (type: "points" | "avoirs" | "solde" | "promo") => {
    switch (type) {
      case "points":
        setRemisePointsEuros(0);
        break;
      case "avoirs":
        setRemiseAvoirsEuros(0);
        break;
      case "solde":
        setRemiseSoldeEuros(0);
        break;
      case "promo":
        if (resetPromoCode) {
          resetPromoCode();
        }
        break;
      default:
        break;
    }
  };


  return (
    <>
      <div className="support-info">
        <p className="info-line sup">
          <strong>Support :</strong> {selectedSupport ? selectedSupport.support : "Aucun support sélectionné"}
        </p>
        <p className="info-line">
          <strong>Parution : </strong>
          {selectedSupport
            ? startDate?.toLocaleDateString("fr-FR", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })
            : "Sélectionner une date"}
          <FaCalendarAlt onClick={handleDatePickerClick} className="calendar-icon" />
        </p>
        {showDatePicker && (
          <DatePicker
            selected={startDate}
            onChange={handleDateChange}
            minDate={new Date()}
            dateFormat="yyyyMMdd"
            inline
          />
        )}
        <p className="info-line">
          <strong>Quantité :</strong> 0 exemplaire(s)
        </p>

        <div className="devis-section">
          <button onClick={generatePDF} className="devis-download-button" disabled={loading}>
            <FaFilePdf className="pdf-icon" />
            Télécharger votre devis
          </button>

            {/* Dropdown pour les remises */}
          <Dropdown className="mt-3">
            <Dropdown.Toggle
              id="dropdown-remises"
              className="d-flex align-items-center gap-2 px-4 py-2 fw-semibold"
              style={{
                background: "linear-gradient(135deg, #4BB0C0 0%, #2A919D 100%)",
                border: "none"
              }}
            >
              <i className="bi bi-percent"></i>
              Utiliser des remises
            </Dropdown.Toggle>

            <Dropdown.Menu className="p-2 shadow-sm border-0" style={{ minWidth: "280px" }}>
              {/* Code Promo */}
              {!user.hasFreeAnnouncement && prixTTC !== 0 && (
                <DiscountItem
                  icon={<FaTicketAlt />}
                  label={
                    appliedDiscount || pendingPromo
                      ? `Code promo appliqué (-${(appliedDiscount || pendingPromo?.finalDiscountPercentage || 0)}%)`
                      : "Utiliser un code promo"
                  }
                  disabled={false}
                  hasDiscount={!!(appliedDiscount || pendingPromo)}
                  onClick={() => setShowPromoModal(true)}
                  onRemove={() => handleRemoveDiscount("promo")}
                />
              )}

              {/* Points */}
              {!user.hasFreeAnnouncement && (
                <DiscountItem
                  icon={<FaStar />}
                  label={
                    remisePointsEuros > 0
                      ? `${remisePointsEuros.toFixed(2)} € de points utilisés`
                      : "Utiliser mes points"
                  }
                  hasDiscount={remisePointsEuros > 0}
                  onClick={() => setShowPointsModal(true)}
                  onRemove={() => handleRemoveDiscount("points")}
                />
              )}

              {/* Avoirs */}
              {availableAvoirs.length > 0 && (
                <DiscountItem
                  icon={<FaMoneyBill />}
                  label={
                    remiseAvoirsEuros > 0
                      ? `${remiseAvoirsEuros.toFixed(2)} € d'avoirs utilisés`
                      : `Utiliser mes avoirs (${user.avoir_balance.toFixed(2)} €)`
                  }
                  hasDiscount={remiseAvoirsEuros > 0}
                  onClick={() => setShowAvoirsModal(true)}
                  onRemove={() => handleRemoveDiscount("avoirs")}
                />
              )}

              {/* Solde Remise */}
              {user.soldeRemise > 0 && (
                <DiscountItem
                  icon={<FaWallet />}
                  label={
                    remiseSoldeEuros > 0
                      ? `${remiseSoldeEuros.toFixed(2)} € de solde remise utilisés`
                      : `Utiliser mon solde remise (${user.soldeRemise.toFixed(2)} €)`
                  }
                  hasDiscount={remiseSoldeEuros > 0}
                  onClick={() => setShowSoldeRemiseModal(true)}
                  onRemove={() => handleRemoveDiscount("solde")}
                />
              )}
            </Dropdown.Menu>
          </Dropdown>

          <div className="tarif-info mt-4">
            <h5 className="tarif-title">Tarif de l'annonce</h5>

            {isFreeAnnouncement && (
              <p className="free-price">
                <span className="free-badge">ANNONCE OFFERTE</span>
              </p>
            )}

            {!isFreeAnnouncement && !discountSentToClient && hasAnyDiscount && (
              <div className="price-breakdown">
                <p className="price-line">
                  <span className="label">Prix initial :</span>
                  <span className="original-price">
                    {prixTTC.toFixed(2)} € TTC
                  </span>
                            </p>

                  {(discountPercentageAmount ?? 0) > 0 && (
                    <p className="price-line discount-line d-flex align-items-center justify-content-between">
                      <span className="label">Remises % :</span>
                      <span className="discount-detail d-flex align-items-center" style={{color:"#F4A261"}}>
                        -{(discountPercentageAmount ?? 0).toFixed(2)} €
                        <FaTimes
                          style={{ cursor: "pointer", marginLeft: "8px", color:"#ff0000"}}
                          onClick={() => handleRemoveDiscount("promo")}
                          title="Annuler cette remise"
                        />
                      </span>
                    </p>
                  )}

                {(pointsDiscountAmount ?? 0) > 0 && (
                    <p className="price-line discount-line d-flex align-items-center justify-content-between">
                      <span className="label">Points :</span>
                      <span className="discount-detail d-flex align-items-center" style={{color:"#F4A261",fontWeight:"800"}}>
                        -{(pointsDiscountAmount ?? 0).toFixed(2)} €
                        <FaTimes
                          style={{ cursor: "pointer", marginLeft: "8px",  color:"#ff0000"}}
                          onClick={() => handleRemoveDiscount("points")}
                          title="Annuler cette remise"
                        />
                      </span>
                    </p>
                  )}

                  {/* Pour les avoirs - AJOUTER le bouton */}
                  {(creditNoteDiscountAmount ?? 0) > 0 && (
                    <p className="price-line discount-line d-flex align-items-center justify-content-between">
                      <span className="label">Avoirs :</span>
                      <span className="discount-detail d-flex align-items-center" style={{color:"#F4A261"}}>
                        -{(creditNoteDiscountAmount ?? 0).toFixed(2)} €
                        <FaTimes
                          style={{ cursor: "pointer", marginLeft: "8px", color:"#ff0000" }}
                          onClick={() => handleRemoveDiscount("avoirs")}
                          title="Annuler cette remise"
                        />
                      </span>
                    </p>
                  )}

                  {(remiseSoldeEuros ?? 0) > 0 && (
                      <p className="price-line discount-line d-flex align-items-center justify-content-between">
                        <span className="label">Solde remise :</span>
                        <span className="discount-detail d-flex align-items-center"  style={{color:"#F4A261"}}>
                          -{(remiseSoldeEuros ?? 0).toFixed(2)} €
                          <FaTimes
                            style={{ cursor: "pointer", marginLeft: "8px",color:"#ff0000"}}
                            onClick={() => handleRemoveDiscount("solde")}
                            title="Annuler cette remise"
                          />
                        </span>
                      </p>
                    )}

                <p className="price-line final-price-line">
                  <span className="label final-label">Prix final :</span>
                    <span className="final-price-highlight">
                      {localAmountToPay.toFixed(2)} € TTC
                    </span>
                </p>
              </div>
            )}

            {!isFreeAnnouncement && !hasAnyDiscount && !discountSentToClient && (
              <>
                <p className="prixht" style={{ height: "35px" }}>
                  {selectedSupport ? `${prixHT.toFixed(2)} € HT` : "Non disponible"}
                </p>
                <p className="prixht" style={{ height: "35px" }}>
                  {selectedSupport ? `${prixTTC.toFixed(2)} € TTC` : "Non disponible"}
                </p>
              </>
            )}
          </div>

          {wantsBilling && selectedBillingClient && (
          <div
            className="d-flex align-items-center justify-content-between p-3 mt-3 bg-light border rounded"
            style={{ minHeight: "80px" }}
          >
            {/* Left content */}
            <div className="d-flex align-items-center gap-3">
              <div
                className="d-flex align-items-center justify-content-center rounded"
                style={{
                  width: "40px",
                  height: "40px",
                  backgroundColor: "#EAF6F7",
                  color: "#2A919D",
                }}
              >
                <i className="bi bi-file-earmark-text-fill fs-5"></i>
              </div>

              <div className="d-flex flex-column">
                <span className="text-muted small">Facturation client</span>
                <span className="fw-bold text-truncate" style={{ maxWidth: "220px" }}>
                  {selectedBillingClient.name}
                </span>
              </div>
            </div>

            {/* Actions */}
            <div className="d-flex align-items-center gap-2">
              <button
                className="btn btn-sm d-flex align-items-center justify-content-center"
                style={{
                  width: "36px",
                  height: "36px",
                  backgroundColor: "#EAF6F7",
                  color: "#2A919D",
                  border: "1px solid #2A919D",
                }}
                onClick={() => setShowBillingClientModal(true)}
                title="Modifier le client"
              >
                <i className="bi bi-pencil"></i>
              </button>

              <button
                className="btn btn-sm d-flex align-items-center justify-content-center btn-outline-danger"
                style={{ width: "36px", height: "36px"}}
                onClick={handleRemoveBillingClient}
                title="Supprimer le client"
              >
                <i className="bi bi-trash"></i>
              </button>
            </div>
          </div>

          )}

          {/* NOUVELLE SECTION : Total des remises avec choix radio */}
          {((remisePourcentage ?? 0) > 0
            || (remisePointsEuros ?? 0) > 0
            || (remiseAvoirsEuros ?? 0) > 0
            || (remiseSoldeEuros ?? 0) > 0
            || (totalDiscountAmount ?? 0) > 0)
            && !discountSentToClient && (
              <div className="discounts-summary mt-3">
                <div className="discount-badges-container">
                  {(totalDiscountAmount ?? 0) > 0 ? (
                    <div className="discount-total">
                      {/* Section des choix radio */}
                      {user?.user_type !== "personne" && (
                        <div className="discount-choice-section p-3 mb-3" style={{
                          backgroundColor: "#f8f9fa",
                          borderRadius: "8px",
                          border: "1px solid #dee2e6"
                        }}>
                          <h6 className="mb-3" style={{ fontSize: "0.95rem", fontWeight: "600" }}>
                            Comment souhaitez-vous utiliser votre remise ?
                          </h6>

                          <div className="d-flex justify-content-between">
                            <div className="total-amount fw-bold" style={{ color: "#F4A261", fontSize: "1.2rem", marginBottom: "5px", marginTop: "-10px" }}>
                              {(totalDiscountAmount ?? 0).toFixed(2)} €
                            </div>

                            <div className="valhead-info-icon-container mt-n3 mb-3" onClick={handleClick} style={{ cursor: "pointer" }}>
                              <span className="valhead-echo-wave valhead-echo-wave-1"></span>
                              <span className="valhead-echo-wave valhead-echo-wave-2"></span>
                              <FaInfoCircle className="info-icon" style={{ fontSize: "1.5rem", color: "#eb8635" }} />
                              {showTooltip && (
                                <div className="tooltip-text" style={{
                                  position: "absolute",
                                  top: "45px",
                                  left: "-300px",
                                  backgroundColor: "#f8f9fa",
                                  color: "#333",
                                  padding: "15px",
                                  borderRadius: "8px",
                                  width: "380px",
                                  fontSize: "0.85rem",
                                  zIndex: 1000,
                                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                  border: "1px solid #dee2e6"
                                }}>
                                  <div style={{ marginBottom: "10px", fontWeight: "600", color: "#333" }}>
                                    <i className="bi bi-info-circle-fill" style={{ color: "#eb8635", marginRight: "8px" }}></i>
                                    Utilisation des remises
                                  </div>
                                  <p style={{ margin: "0 0 10px 0", lineHeight: "1.5" }}>
                                    Les remises accordées sur vos annonces vous appartiennent.
                                  </p>
                                  <p style={{ margin: "0 0 10px 0", lineHeight: "1.5" }}>
                                    À chaque commande, vous pouvez choisir :
                                  </p>
                                  <ul style={{ margin: "0 0 10px 0", paddingLeft: "20px", lineHeight: "1.5" }}>
                                    <li style={{ marginBottom: "5px" }}>
                                      soit de <strong>déduire immédiatement la remise du prix de l'annonce</strong> (le client paie le prix réduit),
                                    </li>
                                    <li>
                                      soit de <strong>conserver la remise dans vos avoirs ALO</strong>, afin de l'utiliser ultérieurement ou de la percevoir par virement.
                                    </li>
                                  </ul>
                                  <p style={{ margin: "0", lineHeight: "1.5", fontSize: "0.8rem", color: "#666" }}>
                                    Les <strong>avoirs</strong> peuvent être utilisés pour payer vos futures annonces ou celles de vos clients.
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>

                          {/* Option 1: Déduire maintenant (par défaut) */}
                          <div
                            className={`form-check mb-3 p-3 valhead-choice-option ${discountChoice === "deduct" ? "valhead-active-choice" : ""}`}
                            onClick={() => handleDiscountChoiceChange("deduct")}
                          >
                            <input
                              className="form-check-input valhead-form-check-input"
                              type="radio"
                              name="discountChoice"
                              id="deductNow"
                              checked={discountChoice === "deduct"}
                              onChange={() => handleDiscountChoiceChange("deduct")}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label valhead-form-check-label ms-2 d-flex flex-column" htmlFor="deductNow" style={{ cursor: "pointer", width: "100%" }}>
                              <div className="fw-bold mb-1 valhead-choice-title">Déduire la remise maintenant</div>
                              <div className="text-muted small mb-2">
                                Prix final de l'annonce : <strong className="valhead-price-highlight">{priceWithDiscount.toFixed(2)} € TTC</strong>
                              </div>
                            </label>
                          </div>

                          {/* Option 2: Conserver dans avoirs */}
                          <div
                            className={`form-check p-3 valhead-choice-option ${discountChoice === "conserve" ? "valhead-active-choice" : ""}`}
                            onClick={() => handleDiscountChoiceChange("conserve")}
                          >
                            <input
                              className="form-check-input valhead-form-check-input"
                              type="radio"
                              name="discountChoice"
                              id="conserveInAvoirs"
                              checked={discountChoice === "conserve"}
                              onChange={() => handleDiscountChoiceChange("conserve")}
                              style={{ cursor: "pointer" }}
                            />
                            <label className="form-check-label valhead-form-check-label ms-2 d-flex flex-column" htmlFor="conserveInAvoirs" style={{ cursor: "pointer", width: "100%" }}>
                              <div className="fw-bold mb-1 valhead-choice-title">Conserver la remise dans mes avoirs</div>
                              <div className="text-muted small mb-1">
                                Prix final de l'annonce : <strong className="valhead-price-highlight">{prixTTC.toFixed(2)} € TTC</strong>
                              </div>
                              <div className="text-muted small">
                                <strong className="valhead-price-highlight">{amountToCreditInAvoirs.toFixed(2)} €</strong> seront crédités dans mes <strong style={{ fontSize: "1rem" }}>avoirs ALO</strong>
                              </div>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="discount-total mt-3 pt-3 border-top d-flex justify-content-between align-items-center">
                      <div className="total-container d-flex flex-column">
                        <div className="total-label fw-bold">
                          <strong>Total des remises</strong>
                        </div>
                        <div className="total-amount fw-bold">-0.00 € (Aucune remise)</div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
        </div>
      </div>

      {/* <SendToClientModal
        show={showSendToClientModal}
        onClose={() => setShowSendToClientModal(false)}
        amount={prixTTC}
        discountAmount={totalDiscountAmount || 0}
        onSoldeSent={handleSoldeSent}
      /> */}

      <SoldeRemiseModal
        show={showSoldeRemiseModal}
        onClose={() => setShowSoldeRemiseModal(false)}
        soldeRemise={user?.soldeRemise || 0}
        maxAmount={Math.max(0, prixTTC - (discountPercentageAmount ?? 0) - (pointsDiscountAmount ?? 0) - (creditNoteDiscountAmount ?? 0))}
        onApply={handleApplySoldeRemise}
        currentAmount={remiseSoldeEuros}
      />
    </>
  )
}

export default ValidationHeader